import React, { useState, useRef, useEffect } from 'react';
import { apiBuscarArticuloPorCodigoBarras } from '../../settings/ApiConfig';
import { Box } from '@mui/material';

import { useRequest } from '../../context/System/RequestContext';
import { useSesion } from '../../context/System/SesionContext';

const STORAGE_PREFIX = 'colector_';

export default function SizeSoftXColectorCodigoBarras({
    TipoVentana = "ENTRADA",
    onRegistrarArticulo,
    onCompletado,
    disabled = false,
    statusBotonCarga = false,
    customArticleLookup,
    limpiarColaAlFallar = false,
    sx,
}) {
    const inputRef = useRef();
    const queueRef = useRef([]);
    const processingRef = useRef(false);
    const { parametrosCajaForm } = useSesion();
    const { GetRequest } = useRequest();

    const pc = (parametrosCajaForm?.caja || "DEFAULT").trim();
    const storageKey = `${STORAGE_PREFIX}${TipoVentana}_${pc}`;

    const [barcode, setBarcode] = useState('');
    const [queueCount, setQueueCount] = useState(0);
    const completadasRef = useRef(0);
    const fallidasRef = useRef(0);

    // Restaurar cola desde localStorage al montar
    useEffect(() => {
        try {
            const stored = localStorage.getItem(storageKey);
            if (stored) {
                queueRef.current = JSON.parse(stored);
                setQueueCount(queueRef.current.length);
            }
        } catch { /* ignore */ }
    }, []);

    // Auto-procesar cuando haya tareas
    useEffect(() => {
        if (queueCount > 0 && !processingRef.current) {
            procesarSiguiente();
        }
    }, [queueCount]);

    const agregarACola = (dataArticulo) => {
        const tarea = {
            id: Date.now().toString(36) + Math.random().toString(36).slice(2, 8),
            data: dataArticulo,
        };
        queueRef.current = [...queueRef.current, tarea];
        localStorage.setItem(storageKey, JSON.stringify(queueRef.current));
        setQueueCount(queueRef.current.length);
    };

    const procesarSiguiente = async () => {
        if (processingRef.current || queueRef.current.length === 0) return;
        processingRef.current = true;

        const tarea = queueRef.current[0];
        let resultado = false;
        try {
            if (typeof onRegistrarArticulo === 'function') {
                resultado = await onRegistrarArticulo(tarea.data);
            }
        } catch {
            resultado = false;
        }

        // Eliminar tarea procesada
        queueRef.current = queueRef.current.filter(t => t.id !== tarea.id);
        if (queueRef.current.length > 0) {
            localStorage.setItem(storageKey, JSON.stringify(queueRef.current));
        } else {
            localStorage.removeItem(storageKey);
        }

        setQueueCount(queueRef.current.length);
        if (resultado) { completadasRef.current++; } else { fallidasRef.current++; }

        processingRef.current = false;

        if (!resultado && limpiarColaAlFallar && queueRef.current.length > 0) {
            queueRef.current = [];
            localStorage.removeItem(storageKey);
            setQueueCount(0);
        }

        if (queueRef.current.length === 0) {
            const totalC = completadasRef.current;
            const totalF = fallidasRef.current;
            completadasRef.current = 0;
            fallidasRef.current = 0;
            if (typeof onCompletado === 'function') {
                await onCompletado(totalC, totalF);
            }
        }
    };

    const procesarCodigo = async (codigo) => {
        let result;
        try {
            if (typeof customArticleLookup === 'function') {
                result = await customArticleLookup(codigo);
            } else {
                const response = await GetRequest({
                    url: apiBuscarArticuloPorCodigoBarras.replace("{codigobarras}", codigo),
                });
                result = response?.result;
            }
        } catch {
            result = null;
        }
        if (result) {
            agregarACola(result);
        }
        setTimeout(() => {
            inputRef.current?.focus();
            inputRef.current?.select();
        }, 0);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            const codigo = event.target.value.trim();
            if (!codigo) return;

            event.target.value = '';
            setBarcode('');

            procesarCodigo(codigo);
        } else if (event.key === 'Delete' || event.key === 'Escape') {
            setBarcode('');
        }
    };

    const handleOnChange = (e) => {
        setBarcode(e.target.value);
    };

    return (
            <Box className="framedetallesventacodigobarrasentradassalidas"
                style={{
                    width: '100%',
                    height: '100%',
                    margin: '0',
                    padding: '0',
                    overflowX: 'hidden',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: '4px',
                    ...sx,
                }}
            >
                <h2 className="framedetallesventalabelcodigobarras" style={{ margin: 0, padding: 0, fontSize: 'inherit' }}>
                    Colector códigos
                    {queueCount > 0 && <span style={{ color: '#f57c00', marginLeft: 8 }}>({queueCount} pend.)</span>}
                </h2>
                <input
                    id="txtCodigoBarras"
                    type="text"
                    inputMode="text"
                    enterKeyHint="enter"
                    tabIndex={1}
                    autoFocus
                    autoComplete="off"
                    name="lector-codigo-barras"
                    aria-autocomplete="none"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck={false}
                    data-lpignore="true"
                    data-1p-ignore="true"
                    className="txtCodigoBarras"
                    ref={inputRef}
                    value={barcode}
                    onChange={handleOnChange}
                    onKeyDown={handleKeyDown}
                    placeholder="Escanear códigos aquí (se acumulan)"
                    disabled={disabled}
                    style={{ width: '100%', maxWidth: '200px' }}
                />
                {statusBotonCarga && (
                    <button onClick={() => document.getElementById('inputArchivo').click()} className="custom-file-upload_general" disabled={disabled}>
                        Cargar escaneos desde archivo.txt
                    </button>
                )}
            </Box>
    );
}
